import React from 'react';
import { Switch, Box, CircularProgress } from '@mui/material';

interface ToggleButtonProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    loading?: boolean;
    disabled?: boolean;
    size?: 'small' | 'medium';
    label?: string;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
    checked,
    onChange,
    loading = false,
    disabled = false,
    size = 'medium',
    label = ''
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!loading && !disabled) {
            onChange(event.target.checked);
        }
    };

    const spinnerSize = size === 'small' ? 10 : 12;

    return (
        <Box className={`toggle-button ${size === 'small' ? 'size-small' : ''}`}>
            <Switch
                checked={!!checked}
                onChange={handleChange}
                disabled={disabled || loading}
                size={size}
                color="primary"
                inputProps={{ 'aria-label': 'Operation Mode Schedule Active' }}
            />
            {loading && (
                <Box className={`loading-overlay ${checked ? 'is-checked' : ''}`}>
                    <CircularProgress size={spinnerSize} thickness={4} className="toggle-button-spinner" />
                </Box>
            )}

            {label && <span className="toggle-button-label">{label}</span>}
        </Box>
    );
};

export default ToggleButton;
